let WorkExData = [
    // {
    //   id: 1,
    //   title: "GSSoC'23",
    //   location: "Remote",
    //   description:
    //     "Open Source Countributor",
    //   buttonText: "",
    //   date: "May 2023 - Aug 2023",
    //   icon: "work",
    // },
    {
      id: 1,
      title: "OneLab Ventures",
      location: "Pune, India (On-Site)",
      description:
        "SDE II",
      buttonText: "",
      date: "Jun 2025 - Present",
      icon: "work",
    },
    {
      id: 2,
      title: "SalventureTech LLC",
      location: "California, LA (Remote)",
      description:
        "SDE II",
      buttonText: "",
      date: "May 2022 - May 2025",
      icon: "work",
    },
    {
      id: 3,
      title: "Dr. Ambedkar College",
      location: "Nagpur, India",
      description:
        "Completed Bachelors's Degree in Computer Application",
      buttonText: "",
      date: "2019 - 2022",
      icon: "school",
    },

  ];
  
  export default WorkExData;